import WorkboardModelsTable from '../WorkboardModelsTable/WorkboardModelsTable';

const WorkboardCurrentModels = () => <WorkboardModelsTable filterType="current" />;

export default WorkboardCurrentModels;
